import { Slider, Stack } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import TypographyWithTooltip from "../../../../common/TypographyWithTooltip.tsx";
import { getThickness } from "../../../../viewer/chart/getThickness.ts";

interface Props {
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function ThicknessItem({ settings, readonlyMode }: Props) {
  const dispatch = useAppDispatch();
  const supported = settings.type === ReportType.DoughnutChart;
  const [draft, setDraft] = React.useState<number>();
  const value = draft ?? 1 - getThickness(settings);

  const formatValueLabel = React.useCallback((value: number) => `${(value * 100).toFixed(0)}%`, []);

  const handleChangeCommitted = (newValue: number) => {
    dispatch(fieldsStateActions.updateSettings({ settings: { thickness: 1 - newValue } }));
    setDraft(undefined);
  };

  if (!supported) {
    return <></>;
  }

  return (
    <Stack direction="row" useFlexGap spacing={3} sx={{ alignItems: "center" }}>
      <TypographyWithTooltip
        label="Thickness"
        tooltipText="Specifies the ring width as a fraction of the total Chart radius"
        typographyProps={{ sx: { color: "text.secondary" } }}
      />
      <HorizontalFill />
      <Slider
        value={value}
        valueLabelDisplay="auto"
        min={0.1}
        max={0.9}
        step={0.1}
        sx={{ py: 0, mr: 1, width: 120 }}
        marks={true}
        disabled={readonlyMode}
        valueLabelFormat={formatValueLabel}
        onChange={(_, value) => setDraft(value)}
        onChangeCommitted={(_, value) => handleChangeCommitted(value)}
      />
    </Stack>
  );
}
